import { forwardRef, useEffect } from "react";
import ContactForm from "./ContactForm";
import Testimonials from "./Testimonials";
import { useDispatch } from "react-redux";
import { setActiveSection } from "../../store";

function ContactSection({ preventIntersectionObserver }, ref) {
  const dispatch = useDispatch();

  /**
   * This is a callback to begin the observation of the div when the component first renders.
   */
  useEffect(() => {
    /**
     * An interaction observer object that allows us to monitor any interaction between the section's
     * div, and the viewport (visible area). It will make the section active when it intersects the
     * viewport.
     */
    const observer = new IntersectionObserver(
      (data) => {
        if (!preventIntersectionObserver.current && data[0].isIntersecting)
          dispatch(setActiveSection("contact"));
      },
      {
        root: null,
        threshold: [0.55],
        rootMargin: "0px 5px 0px 0px",
      }
    );
    observer.observe(ref.current);

    return () => {
      observer.disconnect();
    };
  }, [ref, dispatch, preventIntersectionObserver]);

  return (
    <div
      className="h-full w-max relative ml-10 mr-14 pt-10 flex flex-row items-start"
      ref={ref}
    >
      <ContactForm className="mr-20 mt-9" />
      <Testimonials className="mt-14" />
    </div>
  );
}

export default forwardRef(ContactSection);
